import React, { forwardRef } from 'react'
import { FloatingInspectorButton, FloatingInspectorButtonHandle, FloatingInspectorButtonProps } from '../FloatingInspectorButton'
import Icons from '../../Icons'

export interface FloatingInspectorButtonIconProps
  extends Pick<
    FloatingInspectorButtonProps,
    | 'onClick'
    | 'onLongPressStart'
    | 'onLongPressEnd'
    | 'onLongPressInterval'
    | 'longPressDelay'
    | 'longPressInterval'
    | 'selected'
    | 'disabled'
    | 'disabledStyle'
    | 'showArrow'
    | 'style'
    | 'tooltipText'
    | 'placementTooltip'
    | 'marginTooltip'
    | 'tooltipOptions'
    | 'isSecondaryStyle'
    | 'popoverOnHover'
    | 'popoverContent'
    | 'onPopoverOpenChange'
    | 'borderRadiusStyle'
    | 'nonInteractive'
  > {
  icon: React.ReactNode
  hasCrown?: boolean
  id?: string
  ariaLabel?: string
  disableHover?: boolean
}

const FloatingInspectorButtonIcon = forwardRef<FloatingInspectorButtonHandle, FloatingInspectorButtonIconProps>((
{
  icon,
  onClick,
  onLongPressStart,
  onLongPressEnd,
  onLongPressInterval,
  longPressDelay,
  longPressInterval,
  selected,
  disabled,
  disabledStyle,
  hasCrown,
  showArrow,
  style,
  tooltipText,
  placementTooltip,
  marginTooltip,
  tooltipOptions,
  isSecondaryStyle,
  popoverOnHover,
  popoverContent,
  onPopoverOpenChange,
  id,
  ariaLabel,
  disableHover,
  borderRadiusStyle,
  nonInteractive
}, ref) => (
  <FloatingInspectorButton
    ref={ref}
    onClick={onClick}
    onLongPressStart={onLongPressStart}
    onLongPressEnd={onLongPressEnd}
    onLongPressInterval={onLongPressInterval}
    longPressDelay={longPressDelay}
    longPressInterval={longPressInterval}
    selected={selected}
    disabled={disabled}
    disabledStyle={disabledStyle}
    showArrow={showArrow}
    style={style}
    tooltipText={tooltipText}
    placementTooltip={placementTooltip}
    marginTooltip={marginTooltip}
    tooltipOptions={tooltipOptions}
    isSecondaryStyle={isSecondaryStyle}
    popoverOnHover={popoverOnHover}
    popoverContent={popoverContent}
    onPopoverOpenChange={onPopoverOpenChange}
    id={id}
    ariaLabel={ariaLabel}
    disableHover={disableHover}
    borderRadiusStyle={borderRadiusStyle}
    nonInteractive={nonInteractive}
  >
    {icon}
    {hasCrown && (
      <span style={{ position: 'absolute', top: '-2px', right: '-3px', width: '16px', height: '16px' }}>
        <Icons.PremiumIcon disabled={disabled} />
      </span>
    )}
  </FloatingInspectorButton>
))

export default FloatingInspectorButtonIcon
